export const blockIconsBusinessandpaymentsAttachMoneyNew = (
	<span className='material-symbols-outlined'>attach_money</span>
);
